import { render } from "./CartPanel.vue?vue&type=template&id=728d94e6&scoped=true&ts=true"
import script from "./CartPanel.vue?vue&type=script&lang=ts"
export * from "./CartPanel.vue?vue&type=script&lang=ts"

import "./CartPanel.vue?vue&type=style&index=0&id=728d94e6&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728d94e6"]])

export default __exports__